import { render, staticRenderFns } from "./xhd.vue?vue&type=template&id=bde8c5ae&scoped=true&"
import script from "./xhd.vue?vue&type=script&lang=js&"
export * from "./xhd.vue?vue&type=script&lang=js&"
import style0 from "./xhd.vue?vue&type=style&index=0&id=bde8c5ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde8c5ae",
  null
  
)

export default component.exports